import { render, staticRenderFns } from "./TableRowAvgSellingPricePreDisc.vue?vue&type=template&id=02ff6006&lang=pug&"
import script from "./TableRowAvgSellingPricePreDisc.vue?vue&type=script&lang=js&"
export * from "./TableRowAvgSellingPricePreDisc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02ff6006')) {
      api.createRecord('02ff6006', component.options)
    } else {
      api.reload('02ff6006', component.options)
    }
    module.hot.accept("./TableRowAvgSellingPricePreDisc.vue?vue&type=template&id=02ff6006&lang=pug&", function () {
      api.rerender('02ff6006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/performance-evaluation/table-rows/TableRowAvgSellingPricePreDisc.vue"
export default component.exports